import { defineMessage } from "@lingui/macro";

// Filepicker Default Configuration

export const FILE_PICKER_CONFIG = {
  minCount: 0,
  maxCount: Infinity,
  minSize: 0,
  compression: false,
  maxSize: 104857600,
  fileExtensions: ["*"],
  imageProps: {
    crop: false,
    sizes: [
      [60, 60],
      [900, 400]
    ]
  },
  attachmentConfigProps: {
    sizes: [
      [1200, 800],
      [100, 100]
    ],
    crop: false
  },
  imageConfigProps: {
    sizes: [
      [1200, 800],
      [300, 300]
    ],
    crop: true
  },
  imageExtensions: ["JPG", "JPEG", "BMP", "PNG", "TIF"],
  validSelectedFile: [],
  autoUpload: true
};

export const FILE_PICKER_ERROR = {
  UPLOAD_ERROR: defineMessage`Upload failed due to an unexpected error.`
};
